import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import {
  Grid,
  GridItem,
  Input,
  FormControl,
  FormLabel,
  Button,
  Alert,
  AlertIcon,
  CloseButton,
  AlertDescription,
  Box,
  IconButton,
  InputGroup,
  InputRightElement,
  FormErrorMessage,
} from '@chakra-ui/react';

import { ViewOffIcon } from '@chakra-ui/icons';

import { changepass } from '../../utils/endpoints';
import { PostWithToken } from '../../utils/axiosuitls';

const ViewIconc = () => {
  return (
    <svg width='23' height='15' viewBox='0 0 23 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.25 3.125C10.8984 3.16406 10.3516 3.24219 10 3.32031C10.1562 3.59375 10.2734 4.10156 10.3125 4.375C10.3125 5.58594 9.29688 6.5625 8.125 6.5625C7.8125 6.5625 7.30469 6.44531 7.07031 6.28906C6.95312 6.64062 6.875 7.14844 6.875 7.5C6.875 9.92188 8.82812 11.875 11.25 11.875C13.6719 11.875 15.625 9.92188 15.625 7.5C15.625 5.11719 13.6719 3.125 11.25 3.125ZM22.3438 6.95312C20.2344 2.8125 16.0156 0 11.25 0C6.44531 0 2.22656 2.8125 0.117188 6.95312C0.0390625 7.10938 0 7.34375 0 7.53906C0 7.69531 0.0390625 7.92969 0.117188 8.08594C2.22656 12.2266 6.44531 15 11.25 15C16.0156 15 20.2344 12.2266 22.3438 8.08594C22.4219 7.92969 22.4609 7.69531 22.4609 7.5C22.4609 7.34375 22.4219 7.10938 22.3438 6.95312ZM11.25 13.125C7.38281 13.125 3.82812 10.9766 1.95312 7.5C3.82812 4.02344 7.38281 1.875 11.25 1.875C15.0781 1.875 18.6328 4.02344 20.5078 7.5C18.6328 10.9766 15.0781 13.125 11.25 13.125Z'
        fill='#666666'
      />
    </svg>
  );
};

function ChangePass() {
  const [isOpen, setIsOpen] = useState({
    f1: false,
    f2: false,
    f3: false,
  });
  const [alert, setAlert] = useState({
    type: 'green',
    msg: '',
    visible: false,
  });

  // eslint-disable-next-line
  const [initValsNew, setInitValsNew] = useState({
    current_password: '',
    password: '',
    password_confirmation: '',
  });
  const initialValues = {
    ...initValsNew,
  };
  const validationSchema = Yup.object({
    current_password: Yup.string().required('Current Password is required'),
    password: Yup.string().required('New Password is required'),

    password_confirmation: Yup.string()
      .required('Confirm password is required')
      .oneOf([Yup.ref('password'), null], 'Passwords must match'),
  });
  const onClickReveal = (name) => {
    setIsOpen((prevState) => {
      return {
        ...prevState,
        ...{
          [name]: !isOpen[name],
        },
      };
    });
  };

  const onSubmit = (fields, { setStatus, setSubmitting, resetForm }) => {
    PostWithToken(changepass, fields)
      .then((res) => {
        setAlert((prevState) => {
          return {
            ...prevState,
            ...{
              visible: true,
              msg: res.data.message,
              type: 'green',
            },
          };
        });
        resetForm();
      })
      .catch((error) => {
        setAlert((prevState) => {
          return {
            ...prevState,
            ...{
              visible: true,
              msg:
                error.response.data.message.current_password !== undefined
                  ? error.response.data.message.current_password
                  : error.response.data.message.password,
              type: 'red',
            },
          };
        });
      });
  };
  const _close = () => {
    setAlert((prevState) => {
      return {
        ...prevState,
        ...{ visible: false },
      };
    });
  };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({
        errors,
        touched,
        isSubmitting,
        setFieldValue,
        handleBlur,
        values,
        handleChange,
        setValues,
        resetForm,
      }) => {
        return (
          <Form noValidate>
            <Box>
              {alert.visible && (
                <Alert colorScheme={alert.type} mb='3' w='80%'>
                  <AlertIcon />
                  <AlertDescription>
                    {alert.type === 'red' ? alert.msg.map((e) => e) : alert.msg}
                  </AlertDescription>
                  <CloseButton position='absolute' right='8px' top='8px' onClick={() => _close()} />
                </Alert>
              )}
            </Box>
            <Grid templateRows='repeat(3, 1fr)' gap={5} w={['100%', '50%']}>
              <GridItem colSpan={[2, null]}>
                <FormControl
                  id='current_password'
                  isInvalid={errors.current_password && touched.current_password}
                >
                  <FormLabel>Current Password</FormLabel>

                  <InputGroup>
                    <InputRightElement>
                      <IconButton
                        bg='transparent !important'
                        variant='ghost'
                        aria-label={isOpen['f1'] ? 'Mask password' : 'Reveal password'}
                        icon={isOpen['f1'] ? <ViewOffIcon /> : <ViewIconc />}
                        onClick={() => onClickReveal('f1')}
                        top='1'
                      />
                    </InputRightElement>
                    <Field
                      as={Input}
                      type={isOpen['f1'] ? 'text' : 'password'}
                      placeholder=''
                      name='current_password'
                      autoComplete='off'
                      bg='white'
                      borderRadius='13px'
                      value={values.current_password}
                      className='profile-input'
                    />
                  </InputGroup>
                  <FormErrorMessage> {errors.current_password} </FormErrorMessage>
                </FormControl>
              </GridItem>
              <GridItem colSpan={[2, null]}>
                <FormControl id='password' isInvalid={errors.password && touched.password}>
                  <FormLabel>New Password</FormLabel>
                  <InputGroup>
                    <InputRightElement>
                      <IconButton
                        bg='transparent !important'
                        variant='ghost'
                        aria-label={isOpen ? 'Mask password' : 'Reveal password'}
                        icon={isOpen['f2'] ? <ViewOffIcon /> : <ViewIconc />}
                        onClick={() => onClickReveal('f2')}
                        top='1'
                      />
                    </InputRightElement>
                    <Field
                      as={Input}
                      type={isOpen['f2'] ? 'text' : 'password'}
                      placeholder=''
                      name='password'
                      autoComplete='off'
                      bg='white'
                      borderRadius='13px'
                      value={values.password}
                      className='profile-input'
                    />
                  </InputGroup>
                  <FormErrorMessage> {errors.password} </FormErrorMessage>
                </FormControl>
              </GridItem>
              <GridItem colSpan={[2, null]}>
                <FormControl
                  id='password_confirmation'
                  isInvalid={errors.password_confirmation && touched.password_confirmation}
                >
                  <FormLabel>Confirm Password</FormLabel>
                  <InputGroup>
                    <InputRightElement>
                      <IconButton
                        bg='transparent !important'
                        variant='ghost'
                        aria-label={isOpen ? 'Mask password' : 'Reveal password'}
                        icon={isOpen['f3'] ? <ViewOffIcon /> : <ViewIconc />}
                        onClick={() => onClickReveal('f3')}
                        top='1'
                      />
                    </InputRightElement>
                    <Field
                      as={Input}
                      type={isOpen['f3'] ? 'text' : 'password'}
                      placeholder=''
                      name='password_confirmation'
                      autoComplete='off'
                      isInvalid={errors.password_confirmation && touched.password_confirmation}
                      bg='white'
                      borderRadius='13px'
                      value={values.password_confirmation}
                      className='profile-input'
                    />
                  </InputGroup>
                  <FormErrorMessage> {errors.password_confirmation} </FormErrorMessage>
                </FormControl>
              </GridItem>

              <GridItem colSpan={[2, 1]} mt={2}>
                <Button
                  colorScheme='teal'
                  size='lg'
                  w={{ md: '80%', base: '100%' }}
                  bg='linear-gradient(266.9deg, #43B0A3 0.58%, rgba(67, 176, 163, 0.61) 86.97%);'
                  type='submit'
                  className='button-text'
                >
                  Change Password
                </Button>
              </GridItem>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
}

export default ChangePass;
